import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  fetchAllPermissionCategories,
  selectLoadingPermissionCategories,
  selectPermissionCategories,
  setSelectedPermissionCategory,
} from "./PermissionCategoriesSlice";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useDispatch } from "react-redux";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";

const PermissionCategoriesList: React.FC = () => {
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const isLoading = useSelector(selectLoadingPermissionCategories);

  useEffect(() => {
    thunkDispatch(fetchAllPermissionCategories());
  }, [thunkDispatch]);

  const permissionCategories = useSelector(selectPermissionCategories);

  return (
    <Permission permissionPredicate={(permission) => permission === Permissions.ViewPermissions}>
      <ActivityIndicator isBusy={isLoading}>
        <div className="card">
          <div className="card-header">
            <div className="card-title">Categories</div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">
                <tbody>
                  {permissionCategories.map((category) => (
                    <tr
                      role="button"
                      key={category.permissionCategoryID}
                      data-test-id={`permission-categories-table__category-row-${category.permissionCategoryID}`}
                      onClick={() => dispatch(setSelectedPermissionCategory(category!))}
                    >
                      <td className="text-dark fw-bold text-hover-primary mb-1 fs-6">{category.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ActivityIndicator>
    </Permission>
  );
};

export default PermissionCategoriesList;
